import { when } from 'mobx';
import { once } from '../../js/utils';
import { MraidStore } from '../MraidStore';
import { FormatStateStore, FormatState } from '../FormatStateStore';
import { AnalyticsStore } from '../AnalyticsStore';

interface CreativeLoadedTrackHandlerProps {
  mraidStore: MraidStore;
  formatStateStore: FormatStateStore;
  analyticsStore: AnalyticsStore;
}

export class CreativeLoadedTrackHandler {
  mraidStore: MraidStore;
  formatStateStore: FormatStateStore;
  analyticsStore: AnalyticsStore;

  constructor({
    mraidStore,
    formatStateStore,
    analyticsStore
  }: CreativeLoadedTrackHandlerProps) {
    this.mraidStore = mraidStore;
    this.formatStateStore = formatStateStore;
    this.analyticsStore = analyticsStore;

    this.sendCreativeLoadedTrack = once(this.sendCreativeLoadedTrack);

    when(
      () => this.formatStateStore.state === FormatState.Loaded,
      () => this.sendCreativeLoadedTrack()
    );
  }

  sendCreativeLoadedTrack() {
    this.analyticsStore.sendCreativeTrack('loaded');
  }
}
